import styled from '@emotion/styled';
import { Link } from 'react-router';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import Save from 'lucide-react/dist/esm/icons/save';
// import Button from '../atoms/controls/BaseButton/Button';
// TODO: Button 컴포넌트를 @edusense/shared-ui-kit에 추가 필요
const Button = ({ children, ...props }: any) => <button {...props}>{children}</button>;

// --- Styled Components ---

export const TemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${props => props.theme?.background || '#f9fafb'};
  overflow: hidden;
  position: relative;
`;

export const HeaderBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  background-color: ${props => props.theme?.paper || '#ffffff'};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 10;
  min-height: 48px;
  max-height: 48px;
  position: relative;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f3f4f6;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
`;

export const PageTitle = styled.h1`
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: #111827;
  line-height: 1.2;
`;

export const CourseTitleDisplay = styled.h2`
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 400;
  margin: 0;
  line-height: 1.2;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SaveStatus = styled.div<{ $isSaving?: boolean; $isMobile?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: ${({ $isSaving }) => ($isSaving ? '#6b7280' : '#047857')};
  
  ${({ $isMobile }) => $isMobile && `
    // 모바일일 때 텍스트가 숨겨지므로 아이콘만 남음. 필요시 아이콘 주변 간격 조절.
    // span은 JSX에서 숨겨짐
  `}
`;

export const SaveIcon = styled(Save, {
  shouldForwardProp: (prop: string) => !prop.startsWith('$')
})<{ $isSaving?: boolean }>`
  width: 1rem;
  height: 1rem;
  ${({ $isSaving }) => $isSaving && 'animation: pulse 1.5s infinite;'}
  
  @keyframes pulse {
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
  }
`;

export const SaveChangesButton = styled(Button, {
  shouldForwardProp: (prop: string) => !prop.startsWith('$')
})<{ $isSaving?: boolean; $isIconOnly?: boolean }>`
  background-color: ${({ $isSaving }) => $isSaving ? '#9ca3af' : '#3b82f6'};
  color: white;
  padding: ${({ $isIconOnly }) => $isIconOnly ? '0.5rem' : '0.375rem 0.75rem'};
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 0.375rem;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $isIconOnly }) => $isIconOnly ? '0' : '0.5rem'};
  min-width: ${({ $isIconOnly }) => $isIconOnly ? '36px' : 'auto'};
  width: ${({ $isIconOnly }) => $isIconOnly ? '36px' : 'auto'};
  height: ${({ $isIconOnly }) => $isIconOnly ? '36px' : 'auto'};

  &:hover {
    background-color: ${({ $isSaving }) => $isSaving ? '#9ca3af' : '#2563eb'};
  }

  &:disabled {
    background-color: #9ca3af;
    color: #e5e7eb;
    cursor: not-allowed;
  }
`;

export const PreviewButton = styled.button<{ $isMobile?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f9fafb;
  }

  ${({ $isMobile }) => $isMobile && `
    padding: 0.6rem;
    min-width: auto;
    gap: 0;
    svg {
      margin-right: 0 !important;
    }
    // span은 JSX에서 숨겨짐
  `}
`;

export const PublishButton = styled.button<{ $isPublished?: boolean; $isIconOnly?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $isIconOnly }) => $isIconOnly ? '0' : '0.5rem'};
  background-color: ${({ $isPublished }) => $isPublished ? '#059669' : '#2563eb'};
  border: none;
  border-radius: 0.375rem;
  padding: ${({ $isIconOnly }) => $isIconOnly ? '0.5rem' : '0.375rem 0.75rem'};
  font-size: 0.8rem;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  min-width: ${({ $isIconOnly }) => $isIconOnly ? '36px' : 'auto'};
  width: ${({ $isIconOnly }) => $isIconOnly ? '36px' : 'auto'};
  height: ${({ $isIconOnly }) => $isIconOnly ? '36px' : 'auto'};

  &:hover {
    background-color: ${({ $isPublished }) => $isPublished ? '#047857' : '#1d4ed8'};
  }

  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
`;

export const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  position: relative;
`;

export const SideNav = styled.aside<{ $isFullScreen?: boolean }>`
  width: 240px;
  background-color: ${props => props.theme?.paper || '#ffffff'};
  border-right: 1px solid ${props => props.theme?.border || '#e5e7eb'};
  display: ${props => props.$isFullScreen ? 'none' : 'flex'};
  flex-direction: column;
  
  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }
`;

export const NavMenu = styled.nav`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
`;

export const NavItem = styled(Link, {
  shouldForwardProp: (prop: string) => !prop.startsWith('$')
})<{ $active?: boolean; $isMobile?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  color: ${({ $active }) => ($active ? '#2563eb' : '#4b5563')};
  text-decoration: none;
  background-color: ${({ $active }) => ($active ? '#eff6ff' : 'transparent')};
  border-left: 3px solid ${({ $active }) => ($active ? '#2563eb' : 'transparent')};
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${({ $active }) => ($active ? '#eff6ff' : '#f9fafb')};
    color: ${({ $active }) => ($active ? '#2563eb' : '#1f2937')};
  }
  
  ${({ $isMobile }) => $isMobile && `
    justify-content: center;
    padding: 0.75rem;
    svg {
      width: 20px;
      height: 20px;
    }
    border-left: none;
    border-bottom: 3px solid ${({ $active }: { $active?: boolean }) => ($active ? '#2563eb' : 'transparent')};
  `}
  
  @media (max-width: 768px) {
    ${({ $isMobile, $active }: { $isMobile?: boolean, $active?: boolean }) => !$isMobile && `
      border-left: none;
      border-bottom: 3px solid ${$active ? '#2563eb' : 'transparent'};
      justify-content: center;
      padding: 0.5rem 0;
    `}
  }
`;

export const MainContent = styled.main`
  flex: 1;
  width: 100%;
  padding: 1.5rem 2rem 2.5rem;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  background-color: ${({ theme }) => theme?.background || '#f9fafb'};
  box-sizing: border-box;

  /* 스크롤바 스타일 개선 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media (max-width: 768px) {
    padding: 1.25rem 1.5rem 2rem;
  }
`;

export const MobileNavMenu = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 1rem;
    
    &::-webkit-scrollbar {
      display: none;
    }
    
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

export const NavIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
`; 
